import { IApplication } from "../models/application.model";
import ResourceFactory from "./resource";

const resourceKey = "applicationsCommandCenter";
const resourceUrl = "applications/command/apps";
const resourceIdKey = "id";

const { reducer, fetchList } = ResourceFactory<IApplication>(resourceKey, resourceUrl, resourceIdKey);

export type ApplicationCommandCenterResourcesState = ReturnType<typeof reducer>;
export const fetchApplicationsList = fetchList;

export default reducer;
